import React, { Component } from 'react';
import Slide from 'react-reveal/Slide'

class About extends Component {

    render() {
        return (
            <>
            <Slide left delay={100}>
            <div className="about container my-5" id="about">
                <div className="card">
                    <h4 className="text-muted text-center">About Daniel</h4>
                    <hr/>
                    <p className="lead p-1">
                    A Data Scientist, Machine Learning Engineer with one year of experience in Data Science.
                    I have worked with a number of programming languages such as Python, R, and SQL and managed to successfully 
                    ecxecute over 15 projects both individually and part of a team. 
                    Seeking the position of a Data Scientist in a dynamic environment and develop my skills further.
                    </p>
                </div>
            </div>
            </Slide>
            </>
        );
    }
}

export default About;